<template>
  <div id="app">
            <van-skeleton :row="10" row-width="100%"  style="margin-bottom: 10px;" :loading="loading">
                <template v-if="data.length > 0">
                    <div class="icon-wrap">
                        <img src="../../assets/download.svg">
                    </div>
                    <p class="patch-count">
                       {{_('当前系统有{0}个补丁未更新,',data.length)}}
                        <span>{{_('建议复制补丁链接，将链接传送到可联网PC，使用PC访问链接下载安装。')}}</span>
                    </p>
                    <p class="tips">{{_('注：补丁可能存在依赖关系，请按顺序安装。')}}</p>
                    <van-list>
                        <template v-for="(item, index) in data">
                            <div :key="index">
                                <van-cell  :value="item.releaseTime" title-width="100%" @click="toggle(index)">
                                    <template #title>
                                        <span class="index">{{index + 1}}</span>
                                        <span class="patch-name">{{item.name}}</span>
                                    </template>
                                    <template #right-icon>
                                        <img src="../../assets/up.svg" class="arrow-right" :class="{open: item.open}"/>
                                    </template>
                                </van-cell>
                                <div class="detail" :class="{open: item.open}">
                                    <p class="influence" v-if="_hasInfluence(item)">{{_('影响：')}}{{_getInfluence(item)}}</p>
                                    <p class="description" v-html="getDescription(item.description)"></p>
                                </div>
                            </div>
                        </template>
                    </van-list>
                    <button class="copy" @click="copy">{{_('复制链接')}}</button>
                </template>
                <div v-else class="empty-container">
                    <img src="../../assets/empty.svg" class="empty-img"/>
                    <p>{{_('暂无可用的更新')}}</p>
                </div>
            </van-skeleton>
  </div>
</template>

<script>
import { copy } from '../../util/handle'
import day from 'dayjs'
import {Base64} from 'js-base64';
import i18n from "../../i18n/index";

let base64Reg = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;

export default {
  name: 'App',
  props: {
      infoData: {
        type: Object,
        default: function () {
            return {};
        }
      }
  },
  data () {
      return {
          num: 0,
          loading: false,

      };
  },
  computed: {
      data(){
          return this.infoData.code === 0 ? (this.infoData.data && this.infoData.data.pkg) : [];
      }
  },
  methods: {
      timeFilter (v) {
          return day(v * 1000).format('YYYY-MM-DD hh:mm:ss')
      },
      _hasInfluence (record) {
          return !(record.rebootService === 0 && record.rebootDevice === 0)
      },
      _getInfluence (record) {
          if(!record.restartService && !record.rebootDevice && !record.RestartNetwork) {
              return this._('无');
          }
          return [
              record.restartService  && this._('重启服务'),
              record.rebootDevice && this._('重启设备'),
              record.RestartNetwork && this._('重启网络')
          ].filter(Boolean).join('/')
      },
      getDescription (description) {
          let langMap = {
              'zh-CN': 'default',
              'en-US': 'en'
          };
          let lang = langMap[i18n.getLanguage()] || langMap['zh-CN'];
          if (description && description[lang]) {
              return base64Reg.test(description[langMap['zh-CN']]) ?
                  Base64.decode(description[lang]).replace(/(?:\r\n|\r|\n)/g, '<br>').trim() :
                  description[lang].replace(/(?:\r\n|\r|\n)/g, '<br>').trim();
          }
          return '';
      },
      copy () {
          let text = this.data
            .map((item, index) => `${index+1}. ${item.name}(${item.link})`)
            .join('\n')
          copy(text)
      },
      toggle (index) {
          this.$set(this.data[index], 'open', !this.data[index].open)
      }
  }
}
</script>

<style scoped lang="stylus">
#app
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top 15px
  >>> .van-skeleton__row:not(:first-child)
    width 100% !important

.icon-wrap {
    padding: 30px 0 35px 0;

    text-align: center;
}
.icon-wrap > img {
    width: 88px;
    height: 88px;
}


.patch-count {
    font-size: 18px;
    line-height: 1.5;
    width: 90%;
    margin: 0 auto;
    text-align: left;
}
.patch-count > span {
    font-size: 13px;
}
.tips {
    text-align: center;
}

.copy {
    display: block;
    position: fixed;
    bottom: 0;
    width: 100%;
    line-height: 44px;
    background: #204ED9;
    text-align: center;
    color: #fff;
    font-size: .4rem;
    border: 0;
}
.time {
    width: 200px !important;
}

.index
    margin-right 20px
.detail
    font-size 12px
    max-height 0
    overflow hidden
    transition max-height .25s
    background #f2f2f2
    &.open
        max-height 200px

.influence
    padding-left 18px

.description
    padding-left 18px
    padding-right 18px
    word-break break-all

.empty-container
    text-align center
    font-size 18px
    padding: 45px 0 35px 0;
    color #ccc
.empty-img
    width 88px
    height 88px
.to-form
    color #ff9900
    text-decoration underline
    padding 8px
    text-align center
.arrow-right
    width 12px
    height 12px
    position relative
    top 6px
    margin-left 10px
    transition transform .25s
    &.open
        transform rotate(90deg)

</style>
